var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99996 17.9583C4.05829 17.9583 0.041626 13.9417 0.041626 8.99999C0.041626 4.05832 4.05829 0.0416565 8.99996 0.0416565C13.9416 0.0416565 17.9583 4.05832 17.9583 8.99999C17.9583 13.9417 13.9416 17.9583 8.99996 17.9583ZM8.99996 1.29166C4.74996 1.29166 1.29163 4.74999 1.29163 8.99999C1.29163 13.25 4.74996 16.7083 8.99996 16.7083C13.25 16.7083 16.7083 13.25 16.7083 8.99999C16.7083 4.74999 13.25 1.29166 8.99996 1.29166Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.64163 11.9833C6.48329 11.9833 6.32496 11.925 6.19996 11.8C5.95829 11.5583 5.95829 11.1583 6.19996 10.9167L10.9166 6.19999C11.1583 5.95832 11.5583 5.95832 11.8 6.19999C12.0416 6.44166 12.0416 6.84166 11.8 7.08332L7.08329 11.8C6.96663 11.925 6.79996 11.9833 6.64163 11.9833Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3583 11.9833C11.2 11.9833 11.0416 11.925 10.9166 11.8L6.19996 7.08332C5.95829 6.84166 5.95829 6.44166 6.19996 6.19999C6.44163 5.95832 6.84163 5.95832 7.08329 6.19999L11.8 10.9167C12.0416 11.1583 12.0416 11.5583 11.8 11.8C11.675 11.925 11.5166 11.9833 11.3583 11.9833Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.e79b8ad8808d0743a33db5a41994fcee.svg";
export { ForwardRef as ReactComponent };